var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColoredLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 238.74,
    height: 42,
    viewBox: "0 0 238.74 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4310",
    "data-name": "Group 4310",
    transform: "translate(19029 501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4308",
    "data-name": "Group 4308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17798",
    "data-name": "Path 17798",
    d: "M22.676,20.687V43.454h-7.62V40.625a7.941,7.941,0,0,1-6.98,3.513c-5.11,0-8.076-3.1-8.076-8.806V20.687H7.62v13c0,3.011,1.186,4.243,3.559,4.243,2.51,0,3.878-1.46,3.878-4.472V20.687Z",
    transform: "translate(-19029 -511.67)",
    fill: "#d80024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17799",
    "data-name": "Path 17799",
    d: "M79.2,31.318a16.214,16.214,0,0,1-1.232,6.571,9.234,9.234,0,0,1-8.85,5.474,7.97,7.97,0,0,1-6.843-3.148V51.94h-7.62V19.958h7.436v2.737a8.016,8.016,0,0,1,7.027-3.422,9.2,9.2,0,0,1,8.85,5.52A16.138,16.138,0,0,1,79.2,31.318m-8.12,0a8.935,8.935,0,0,0-.548-3.559A3.969,3.969,0,0,0,66.6,25.478c-2.875,0-4.425,1.825-4.425,5.2V31.91c0,3.377,1.551,5.2,4.425,5.2a3.968,3.968,0,0,0,3.924-2.281,8.686,8.686,0,0,0,.548-3.513",
    transform: "translate(-19057.186 -510.94)",
    fill: "#d80024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17800",
    "data-name": "Path 17800",
    d: "M184.583,20.007h7.575V22.06c1.186-1.917,2.464-2.692,4.289-2.692a4.179,4.179,0,0,1,4.472,4.426,4.228,4.228,0,0,1-4.38,4.425,3.873,3.873,0,0,1-3.559-2.053c-.639.275-.776.639-.776,2.236V42.773h-7.62Z",
    transform: "translate(-19124.199 -510.989)",
    fill: "#d80024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17801",
    "data-name": "Path 17801",
    d: "M243.387,29.63V42.724h-7.62V40.033c-1.505,2.1-3.833,3.331-7.528,3.331-3.6,0-6.3-1.278-7.437-3.833a7.071,7.071,0,0,1-.639-3.239,7.867,7.867,0,0,1,.547-3.1c1.644-3.558,6.069-4.38,11.635-4.38h3.422v-.365a5.2,5.2,0,0,0-.365-2.464q-.685-1.5-3.149-1.5c-1.779,0-2.783.457-3.239,1.46a4.107,4.107,0,0,0-.275,1.368h-7.756a8.458,8.458,0,0,1,.684-3.193c1.507-3.331,5.384-4.837,10.494-4.837,5.52,0,8.761,1.46,10.266,4.745a14.4,14.4,0,0,1,.959,5.612m-8.03,6.251a5.19,5.19,0,0,0,.41-2.509v-.32h-2.921c-2.188,0-3.968.229-4.47,1.414a2.181,2.181,0,0,0-.229,1,2.245,2.245,0,0,0,.229,1.1c.457,1,1.642,1.369,3.011,1.369,2.054,0,3.377-.731,3.97-2.053",
    transform: "translate(-19142.549 -510.94)",
    fill: "#d80024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17802",
    "data-name": "Path 17802",
    d: "M299.13,1.183V33.394h-7.436V30.657a8.034,8.034,0,0,1-7.027,3.376,9.166,9.166,0,0,1-8.85-5.474,16.212,16.212,0,0,1-1.232-6.57,16.136,16.136,0,0,1,1.232-6.525,9.159,9.159,0,0,1,8.85-5.52,8.028,8.028,0,0,1,6.845,3.149V1.183ZM291.6,21.349c0-3.376-1.552-5.2-4.426-5.2a3.969,3.969,0,0,0-3.924,2.281,8.943,8.943,0,0,0-.547,3.559,9.2,9.2,0,0,0,.547,3.6,3.97,3.97,0,0,0,3.924,2.281c2.875,0,4.426-1.825,4.426-5.2Z",
    transform: "translate(-19170.617 -501.61)",
    fill: "#d80024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17803",
    "data-name": "Path 17803",
    d: "M129.4,15.65v5.873h4.912l-.184.767c-.613,2.551-3.662,4.263-6.126,4.263-3.427,0-7.865-1.651-7.865-9.518,0-6.513,2.858-9.626,7.226-9.626,2.389,0,4.23.565,5.338,2.229a5.924,5.924,0,0,1,.932,2.566h8.722a11.2,11.2,0,0,0-3.081-7.568l-.155-.159C136.463,1.6,132.476,0,127.541,0c-10.071,0-16.579,6.7-16.579,17.081,0,12,8.242,16.259,15.3,16.259,3.96,0,7.53-1.183,9.7-3.512l.1,2.956h6.825V15.65Z",
    transform: "translate(-19086.229 -501)",
    fill: "#d80024"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4309",
    "data-name": "Group 4309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17804",
    "data-name": "Path 17804",
    d: "M348.1,48.272V29.625h3.271V45.393h8.219v2.879Z",
    transform: "translate(-19208.531 -516.279)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17805",
    "data-name": "Path 17805",
    d: "M377.022,29.941a1.817,1.817,0,1,1,1.817,1.817,1.817,1.817,0,0,1-1.817-1.817m.364,4.054h2.936V47.5h-2.936Z",
    transform: "translate(-19223.449 -515.505)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17806",
    "data-name": "Path 17806",
    d: "M393.152,53.751l-5.507-13.5h3.131l3.942,10.12,3.942-10.12h3.159l-5.507,13.5Z",
    transform: "translate(-19228.928 -521.758)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17807",
    "data-name": "Path 17807",
    d: "M419.974,29.941a1.817,1.817,0,1,1,1.817,1.817,1.817,1.817,0,0,1-1.817-1.817m.363,4.054h2.936V47.5h-2.936Z",
    transform: "translate(-19245.602 -515.505)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17808",
    "data-name": "Path 17808",
    d: "M443.751,53.393V44.951c0-2.1-1.062-2.8-2.712-2.8a4.444,4.444,0,0,0-3.467,1.817v9.421h-2.936v-13.5h2.936v1.845a6.388,6.388,0,0,1,4.752-2.181c2.907,0,4.362,1.566,4.362,4.333v9.505Z",
    transform: "translate(-19253.164 -521.401)",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17809",
    "data-name": "Path 17809",
    d: "M467.679,54.736a5.234,5.234,0,0,0,4.277,1.733c1.929,0,4-.894,4-3.662V51.185a5.48,5.48,0,0,1-4.333,2.236c-3.439,0-5.983-2.488-5.983-6.933,0-4.361,2.516-6.933,5.983-6.933a5.377,5.377,0,0,1,4.333,2.209V39.891h2.936v12.8c0,4.864-3.606,6.179-6.933,6.179a7.62,7.62,0,0,1-5.647-2.013Zm8.275-10.763a4.382,4.382,0,0,0-3.466-1.817c-2.321,0-3.8,1.734-3.8,4.334s1.482,4.333,3.8,4.333A4.381,4.381,0,0,0,475.954,49Z",
    transform: "translate(-19269.152 -521.401)",
    fill: "#040506"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredLogo);
export default __webpack_public_path__ + "static/media/colored-logo.370cd2362b02ac19f550144fda9a0b30.svg";
export { ForwardRef as ReactComponent };